import React from 'react';
import { ModeType } from './ServiceBoxEnum';
import ServiceBoxRegular from './ServiceBoxRegular/ServiceBoxRegular';
import ServiceBoxTiny from './ServiceBoxTiny/ServiceBoxTiny';
const ServiceBoxMain = ({ modeType, actionName, backgroundImage,isHaveBadge,badgeText ,callback }) => {

    const viewServiceBox = () => {
        switch (modeType) {
            case ModeType.Regular:
                return <ServiceBoxRegular 
                callback={callback} 
                isHaveBadge={isHaveBadge} 
                badgeText={badgeText} 
                actionName={actionName} 
                backgroundImage={backgroundImage}>
                </ServiceBoxRegular>
            case ModeType.Tiny:
                return <ServiceBoxTiny  
                isHaveBadge={isHaveBadge} 
                badgeText={badgeText} 
                callback={callback} 
                actionName={actionName}
                ></ServiceBoxTiny>
            case ModeType.Unknown:
                return <></>
        }
    }
    return <>{viewServiceBox()}</>;
}



export default ServiceBoxMain;